import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpHelperService } from "@shared/services/http-helper.service";
import { Observable } from "rxjs";

@Injectable()
export class SalesManagementReportsService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getReportsLov({ userId, skipLoading = false }): Observable<any> {
    return this.httpHelperService.get(
      `/report/lov?userId=${userId}&skipLoading=${skipLoading}`,
    );
  }

  public getPerformanceReport(payload): Observable<any> {
    return this.httpHelperService.post(
      `/performance-report?userId=${payload.userId}`,
      payload.request,
    );
  }

  public getReportYear(userId): Observable<any> {
    return this.httpHelperService.get(
      `/performance-report/year?userId=${userId}`,
    );
  }

  public downloadPerformanceReport(
    userId: string,
    payload: any,
  ): Observable<ArrayBuffer> {
    return this.httpHelperService.generateReport(
      `/performance-report/pdf?userId=${userId}`,
      payload,
      {
        headers: new HttpHeaders({
          Accept: "application/json",
        }),
        responseType: "arraybuffer",
      },
    );
  }

  public getCampaignReport(payload: any): Observable<ArrayBuffer> {
    return this.httpHelperService.generateReport(
      `/campaign-report?userId=${payload.userId}`,
      payload.request,
      {
        headers: new HttpHeaders({
          Accept: "application/json",
        }),
        responseType: "arraybuffer",
      },
    );
  }
}
